export const common = {
  welcome: '欢迎',
  home: '首页',
  about: '关于我们',
  services: '服务',
  contact: '联系我们',
  learnMore: '了解更多',
  getStarted: '开始',
  submit: '提交',
  cancel: '取消',
  close: '关闭',
  save: '保存',
  edit: '编辑',
  delete: '删除',
  search: '搜索',
  loading: '加载中...',
  error: '发生错误',
  success: '成功',
  reserveNow: '立即预订',
};